export enum AdminAddPharmacistFormItemLabel {
  Email = "Email",
  FirstName = "Ime",
  LastName = "Prezime",
  Pharmacy = "Ljekarna",
}
